module.exports = __webpack_public_path__ + "img/defaultProductImg_KIE.c2073bd3.png";